import { createDateByTimezoneOffset, formatDate } from '@/helpers/time';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { Button, Card, DatePicker, Popover } from '@shopify/polaris';
import { CalendarIcon } from '@shopify/polaris-icons';
import { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { DatePickerStyled } from './styled';

interface IProps {
  disabledActivator?: boolean;
  date?: Date;
  setDate?: (date: Date) => void;
  disableDatesBefore?: Date;
}

function SingleDatePicker(props: IProps) {
  const dataSettings = useSelector(dataSettingsSelector);
  const [popoverActive, setPopoverActive] = useState(false);

  const now = useMemo(
    () => createDateByTimezoneOffset(dataSettings.date_timezone_offset, new Date()),
    [dataSettings.date_timezone_offset],
  );
  const [{ month, year }, setDate] = useState({ month: (props.date ?? now).getMonth(), year: (props.date ?? now).getFullYear() });

  const handleMonthChange = useCallback((month: number, year: number) => setDate({ month, year }), []);

  const disableDatesBefore = useMemo(() => {
    return props.disableDatesBefore ?? new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }, [now, props.disableDatesBefore]);

  return (
    <Popover
      active={popoverActive}
      autofocusTarget="none"
      //   preferredAlignment="left"
      //   preferredPosition="below"
      //   fluidContent
      sectioned={false}
      fullHeight
      activator={
        <Button icon={CalendarIcon} onClick={() => setPopoverActive((prev) => !prev)} disabled={props.disabledActivator}>
          {formatDate(props.date ?? now, dataSettings.date_format)}
        </Button>
      }
      onClose={() => {
        setPopoverActive(false);
      }}
    >
      <DatePickerStyled>
        <Card>
          <DatePicker
            month={month}
            year={year}
            onChange={(date) => {
              props.setDate?.(date.start);
            }}
            onMonthChange={handleMonthChange}
            selected={props.date}
            disableDatesBefore={disableDatesBefore}
          />
        </Card>
      </DatePickerStyled>
    </Popover>
  );
}

export default SingleDatePicker;
